"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OperationType;
(function (OperationType) {
    OperationType["Mutation"] = "mutation";
    OperationType["Query"] = "query";
    OperationType["Subscription"] = "subscription";
})(OperationType || (OperationType = {}));
exports.default = OperationType;
//# sourceMappingURL=OperationType.js.map


//////////////////
// WEBPACK FOOTER
// ./~/gql-query-builder/build/OperationType.js
// module id = 112
// module chunks = 1